import classesK from '../kalkulatori.module.css'
import { useEffect, useState } from 'react'
import InfoBar from '../redesign/components/InfoBar'
import OddsCalculator from '../redesign/components/OddsCalculator'
import ResultsSection from '../redesign/components/ResultsSection'
import {
  footballSectionsData,
  getInitialData,
} from './FudbalSveIgreResultsData'
import {
  calculateFudbalSveIgre,
  isValidFudbalSveIgreInput,
} from './FudbalSveIgreCalculator'

const calculatorType = 'Fudbal - sve igre'

let FudbalSveIgre = () => {
  const [showInputArea, setShowInputArea] = useState(true)
  const [disabled, setDisabled] = useState(true)
  const [data, setData] = useState(getInitialData())

  useEffect(() => {
    setDisabled(!isValidFudbalSveIgreInput(data.values))
  }, [data.values])

  const clearFields = () => {
    setData(getInitialData())
    setShowInputArea(true)
  }

  const handleCalculate = () => {
    const results = calculateFudbalSveIgre(data.values)

    if (!results) {
      setDisabled(true)
      return
    }

    setData((prev) => ({
      ...prev,
      results,
    }))
  }

  const handleButtonClick = () => {
    if (!showInputArea) {
      clearFields()
      return
    }

    handleCalculate()
    setShowInputArea(false)
  }

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={calculatorType} onRefresh={clearFields} />
      <div className={classesK.contentContainer}>
        <div className={classesK.submitWrapper}>
          <span>Unesi nove obračunske podatke</span>
          <button onClick={handleButtonClick} disabled={disabled}>
            {showInputArea ? 'Unesi obračunske podatke' : 'Prikaži rezultate'}
          </button>
        </div>
        {showInputArea && (
          <>
            <div className={classesK.sectionTitle}>
              Upiši kvote za ishod utakmice
            </div>
            <OddsCalculator
              data={data.values}
              setData={setData}
              field={'odds'}
              labelPrefix={[' KI 1', 'KI X', 'KI 2']}
              type={['number', 'number', 'number']}
              step={['0.1', '0.1', '0.1']}
              min={['0.1', '0.1', '0.1']}
              rows={1}
            />
            <div className={classesK.sectionTitle}>
              Upiši kvote za ukupno golova
            </div>
            <OddsCalculator
              data={data.values}
              setData={setData}
              field={'totalGoals'}
              labelPrefix={[
                'UG 0-2 ( od 0 do 2 gola )',
                'UG 3+ ( 3 ili više golova )',
              ]}
              type={['number', 'number']}
              step={['0.1', '0.1']}
              min={['0.1', '0.1']}
            />
            <div className={classesK.sectionTitle}>
              Upiši kvote za "Oba daju gol"
            </div>
            <OddsCalculator
              data={data.values}
              setData={setData}
              field={'bothTeams'}
              labelPrefix={[
                'GG ( oba tima daju gol na ut. )',
                'NEGG (min. jedan tim ne daje gol )',
              ]}
              type={['number', 'number']}
              step={['0.1', '0.1']}
              min={['0.1', '0.1']}
            />
          </>
        )}
        {!showInputArea && (
          <div className={classesK.sectionResults}>
            {footballSectionsData.map(({ title, key, sections }) =>
              sections.map(
                ({ subtitle, subKey, names, withPercent = true }, idx) => (
                  <ResultsSection
                    key={`${key}-${subKey}`}
                    title={idx === 0 ? title : undefined}
                    subtitle={subtitle}
                    names={names}
                    results={data.results?.[key]?.[subKey]}
                    withPercent={withPercent}
                    layoutPattern={'...-...+'}
                  />
                )
              )
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default FudbalSveIgre
